import Vue from 'vue';
import Router from 'vue-router';
// eslint-disable-next-line import/no-cycle
import store from '@/store'; // TODO: remove cycle dependency on modules/admin
import Login from '@/views/auth/Login.vue';
import ForgotPassword from '@/views/auth/ForgotPassword.vue';
import ResetPassword from '@/views/auth/ResetPassword.vue';
import Dashboard from '@/views/Dashboard.vue';
import Collection from '@/views/collection/Index.vue';
import CollectionList from '@/views/collection/List.vue';
import CollectionRead from '@/views/collection/Read.vue';
import CollectionUpsert from '@/views/collection/Upsert.vue';
import Users from '@/views/users/Index.vue';
import UsersList from '@/views/users/List.vue';
import UserUpsert from '@/views/users/Upsert.vue';
import Forbidden from '@/views/misc/Forbidden.vue';
import Reports from '@/views/reports/Index.vue';
import ReportCollectionStatus from '@/views/reports/ReportCollectionStatus.vue';
import ReportProductivity from '@/views/reports/ReportProductivity.vue';
import ReportKeyWords from '@/views/reports/ReportKeyWords.vue';
import ReportDocumentDate from '@/views/reports/ReportDocumentDate.vue';
import ReportDocumental from '@/views/reports/ReportDocumental.vue';
import ReportSearch from '@/views/reports/ReportSearch.vue';
import Soon from '@/views/misc/Soon.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      props: true,
    }, {
      path: '/forgot',
      name: 'ForgotPassword',
      component: ForgotPassword,
      // eslint-disable-next-line camelcase
      props: route => ({ accessToken: route.query.access_token }),
    }, {
      path: '/resetar-senha',
      name: 'ResetPassword',
      component: ResetPassword,
      // eslint-disable-next-line camelcase
      props: route => ({ accessToken: route.query.access_token }),
    }, {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      redirect: { name: 'Acervo listar' },
      children: [
        {
          name: 'Acervo',
          path: '/acervo',
          component: Collection,
          redirect: { name: 'Acervo listar' },
          children: [
            {
              name: 'Acervo listar',
              path: '/acervo/listar',
              component: CollectionList,
            },
            {
              name: 'Acervo editar',
              path: '/acervo/upsert/:acervo/:id?',
              component: CollectionUpsert,
              meta: { requiresAuth: ['admin', 'operador'] },
            },
            {
              name: 'Acervo ver',
              path: '/acervo/ver/:id',
              component: CollectionRead,
              meta: { requiresAuth: true },
            },
          ],
        },
        {
          name: 'Usuários',
          path: '/usuarios',
          meta: { requiresAuth: ['admin'] },
          component: Users,
          redirect: { name: 'Usuários listar' },
          children: [
            {
              name: 'Usuários listar',
              meta: { requiresAuth: ['admin'] },
              path: '/usuarios/listar',
              component: UsersList,
            },
            {
              name: 'Usuário editar',
              meta: { requiresAuth: ['admin'] },
              path: '/usuarios/upsert/:id?',
              component: UserUpsert,
            },
          ],
        }, {
          name: 'Relatórios',
          path: '/relatorios',
          meta: { requiresAuth: ['admin', 'operador'] },
          component: Reports,
        }, {
          name: 'Proibido',
          path: '/dashboard/proibido',
          component: Forbidden,
        }, {
          name: 'Em breve',
          meta: { requiresAuth: true },
          path: '/dashboard/em-breve',
          component: Soon,
        },
      ],
    },
    {
      path: '/relatorio/status-do-acervo',
      name: 'Relatório Status do Acervo',
      component: ReportCollectionStatus,
      meta: { requiresAuth: true },
    },
    {
      path: '/relatorio/produtividade',
      name: 'Relatório Produtividade',
      component: ReportProductivity,
      meta: { requiresAuth: true },
    },
    {
      path: '/relatorio/palavras-chave',
      name: 'Relatório Palavras-chave',
      component: ReportKeyWords,
      meta: { requiresAuth: true },
    }, {
      path: '/relatorio/documental',
      name: 'Relatório Espécie Documental/Tipo de Objeto',
      component: ReportDocumental,
      meta: { requiresAuth: true },
    },
    {
      path: '/relatorio/data-do-documento',
      name: 'Relatório Data do Documento',
      component: ReportDocumentDate,
      meta: { requiresAuth: true },
    },
    {
      path: '/relatorio/consulta',
      name: 'Relatório Consulta',
      component: ReportSearch,
      meta: { requiresAuth: true },
    },
  ],
});

// Sync routes with auth module
store.dispatch('auth/syncRouter', router);

export default router;
